<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <h3 v-if="order.supplier">{{ order.supplier.name }}</h3>
        <p> {{
                  moment(new Date(order.created_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}</p>
       <table class="table">
         <tr class="bg-light font-weight-bold">
                  <td>Part</td>
                  <td>Qty</td>
                  <td>On Hand</td>
                  <td>On Order</td>
                </tr>
         <tr v-for="part in order.order_items" :key="part.id">
           <td>
             <strong> {{ part.part.code }} </strong> - {{ part.part.description }}
           </td>
           <td>
            {{ part.quantity }}
           </td>
            <td>
            {{ part.part.on_hand }}
           </td>
           <td>
            {{ part.part.on_order }}
           </td>
         </tr>
       </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import orderRepo from "@/api/repos/orderRepo";

export default {
  props: ["id"],

  components: {
   
  },

  mounted() {
    this.getOrder();
  },

  data() {
    return {
      loading: false,
      order: {},
    };
  },

  methods: {
    async getOrder() {
      try {
        this.loading = true;
        let { data } = await orderRepo.get(this.id);
        this.order = data.order;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
